// src/components// src/components/PromoModalDynamic.jsx
import React from 'react';

const PromoModalDynamic = ({ product, onClose }) => {
  if (!product) return null;


const price = (Number(product.price) / 100).toFixed(2);
const goal = product.preorderGoal || null;
const currentSales = product.preorders ?? 0;
const progress = goal ? Math.min(100, (currentSales / goal) * 100) : 0;



  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        cursor: 'pointer'
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#111',
          padding: '2rem',
          borderRadius: '12px',
          maxWidth: '500px',
          width: '90%',
          textAlign: 'center',
          color: '#fff',
        }}
      >
        {/* Promotional Message */}
        <div style={{
          background: '#000000',
          color: '#fff',
          padding: '0.8rem 1rem',
          borderRadius: '8px',
          marginBottom: '1rem',
          fontWeight: 'bold'
        }}>
          🎁 Everybody who smashes that preorder submit button and follows through with a buy; gets(exclusively) the next 3 albums I make <u>FREE</u> — instant download when each one is finished, no waiting for preorder goals to be met!
        </div>

        {/* Product Info */}
        <h2>{product.name}</h2>

        

<img
  src={product.images?.modal}
  alt={product.name}
  style={{
    width: '260px',
    height: '260px',
    objectFit: 'contain',
    margin: '1rem auto',
    display: 'block'
  }}
/>




        {product.price && <p>Price: ${price}</p>}

        {/* Progress Bar */}
       {/* Progress Bar */}
{goal && (
  <div style={{ margin: '1rem 0' }}>
    <div style={{ height: '10px', background: '#444', borderRadius: '5px', overflow: 'hidden' }}>
      <div style={{ width: `${progress}%`, height: '100%', background: '#ff4081' }} />
    </div>
    <small>{currentSales} / {goal} sold</small>
  </div>
)}

    

        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            display: 'block',
            margin: '1rem auto 0',
            padding: '0.5rem 1rem',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            background: '#555',
            color: '#fff'
          }}
        >
          Close ×
        </button>
      </div>
    </div>
  );
};

export default PromoModalDynamic;
